import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Alert, AlertTitle, Container } from '@mui/material';
import { Main } from '../layouts';

const ErrorFallBackUI = ({ error, resetErrorBoundary }: { error: Error, resetErrorBoundary: () => void }) : JSX.Element => {

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main>
      <Box
        bgcolor={theme.palette.background.default}
        position={'relative'}
        minHeight={'calc(100vh - 247px)'}
        display={'flex'}
        justifyContent={'center'}
        height={1}
        marginTop={4}
        paddingTop={12}
      >
        <Container>
          <Grid container>
            <Grid
              container
              alignItems={'center'}
              justifyContent={'center'}
              size={12}
            >
              <Box>
                <Typography
                  variant="h4"
                  component={'h4'}
                  align={isMd ? 'left' : 'center'}
                  sx={{ fontWeight: 700 }}
                  marginBottom={4}
                >
                  Something went wrong:
                </Typography>
                <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
                    {error.message}
                </Alert>
                <Typography
                  variant="h6"
                  component="p"
                  color="text.secondary"
                  align={isMd ? 'left' : 'center'}
                  marginTop={4}
                >
                  If you think this is a problem with us, please{' '}
                  <Link href={'/About/ContactUs'} underline="none">
                    tell us.
                  </Link>
                </Typography>
                <Box
                  marginTop={4}
                  display={'flex'}
                  justifyContent={{ xs: 'center', md: 'flex-start' }}
                >
                  <Button
                    component={Link}
                    variant="contained"
                    color="primary"
                    size="large"
                    href={'/'}
                  >
                    Back home
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Main>
  );
}

export default ErrorFallBackUI;